"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var root = require("window-or-global");
// creates the boilerplate snippet on the bottom of <body>
function insertButtonHtml(deptId, chatHost) {
    if (!root.document) {
        return;
    }
    var container = createContainerTag();
    container.appendChild(createReceiverTag());
    container.appendChild(createScriptTag(deptId, chatHost));
    root.document.body.appendChild(container);
}
exports.insertButtonHtml = insertButtonHtml;
// create a invisible div to hold the container
function createContainerTag() {
    var container = root.document.createElement('div');
    container.setAttribute('style', 'display: none');
    return container;
}
// create a receiver-container (will hold the actual button later)
function createReceiverTag() {
    if (!root.document) {
        return;
    }
    var receiver = root.document.createElement('span');
    receiver.setAttribute('id', 'optiRealPersonContent');
    return receiver;
}
// create a script tag with the predefined content, deptid == 16 for BEA
function createScriptTag(depId, chatHost) {
    if (!root.document) {
        return;
    }
    var script = root.document.createElement('script');
    script.id = 'chat94';
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('deptid', depId);
    script.innerHTML = scriptContent.replace('$DEPID', depId.toString());
    script.innerHTML = script.innerHTML.replace('$CHATHOST', chatHost);
    return script;
}
var scriptContent = "\n<!--\nvar rpChatConfig = rpChatConfig || {};\nrpChatConfig.deptId = $DEPID;\nrpChatConfig.pagename = \"\";\n(function () {\n  var realpersonChatLoader = function () {\n    var e = document.createElement('script');\n    e.type = 'text/javascript';\n    e.async = true;\n    e.id = 'realpersonChatLoader';\n    e.src = 'https://$CHATHOST/system/scripts/loadchatmodul.js';\n    document.getElementsByTagName('head')[0].appendChild(e);\n  };\n  realpersonChatLoader();\n})();\n//-->\n";
//# sourceMappingURL=insert_button_html.js.map